import axiosInstance from '@/plugins/axios';

export default class ServiceAuditoria {
  static listar = (filtros = {}, { page = 0, size = 50 } = {}) =>
    axiosInstance.post('audit/user-actions', { ...filtros, page, size });
  static opcoes = (from, to) => axiosInstance.get('audit/filters', { params: { from_: from, to } });
  static exportar = (filtros = {}) =>
    axiosInstance.post('audit/export', filtros, { responseType: 'blob' });
}
